import { Button } from "./Button";
import { Modal } from "react-bootstrap";

interface ConfirmDialogProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
    title: string;
    message?: string;
    htmlMessage?: string;
    confirmText?: string;
    cancelText?: string;
}

export function ConfirmDialog({ 
    show, 
    onHide, 
    onConfirm, 
    title, 
    message, 
    htmlMessage,
    confirmText = "Confirm", 
    cancelText = "Cancel"
}: ConfirmDialogProps) {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {htmlMessage ? (
                    <div dangerouslySetInnerHTML={{ __html: htmlMessage }} />
                ) : (
                    message
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onHide}>
                    {cancelText}
                </Button>
                <Button className="btn-main"  onClick={onConfirm}>
                    {confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
} 